import type { PageComponentPreviewProps } from '../../../../types/element';
import PreviewComponentLabel from './previewComponentLabel/PreviewComponentLabel';
import { Calendar as CalendarIcon } from '@phosphor-icons/react';

const Calendar = ({ label }: PageComponentPreviewProps) => {
    return (
        <div data-testid="component-preview-calendar" className="component-preview-calendar">
            <PreviewComponentLabel labelText={label} />
            <div
                data-testid="component-preview-calendar-mock"
                className="component-preview-calendar-mock"
            >
                <CalendarIcon
                    data-testid="component-preview-calendar-mock-icon"
                    className="component-preview-calendar-mock-icon"
                    weight="thin"
                    size={192}
                />
            </div>
        </div>
    );
};

export default Calendar;
